import * as React from 'react';

import { getUserAgentOperatingSystemDetails } from '@/shared/modules/user-agent/utils';

export const useGetOsDetails = () => {
  const [osType, setOsType] = React.useState<string | undefined>();
  const [osVersion, setOsVersion] = React.useState<string | undefined>();

  React.useEffect(() => {
    const osDetails = getUserAgentOperatingSystemDetails();
    setOsType(osDetails.name);
    setOsVersion(osDetails.version);
  }, []);

  return {
    osType,
    osVersion,
  };
};
